import type { ComponentPropsWithoutRef, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useOrgRegisterDialogOptional } from '@/contexts/OrgRegisterDialogContext';
import { cn } from '@/lib/utils';

interface OrgJoinClubLinkProps extends ComponentPropsWithoutRef<'button'> {
  joinPath: string;
  className?: string;
  children: ReactNode;
}

/**
 * Opens the org registration modal for club signup, then continues to membership join.
 * Falls back to navigating to the join page when the modal provider is unavailable.
 */
export function OrgJoinClubLink({
  joinPath,
  className,
  children,
  type = 'button',
  ...buttonProps
}: OrgJoinClubLinkProps) {
  const orgRegister = useOrgRegisterDialogOptional();

  if (!orgRegister) {
    return (
      <Link to={joinPath} className={className}>
        {children}
      </Link>
    );
  }

  return (
    <button
      type={type}
      className={cn(className)}
      onClick={() => orgRegister.openOrgRegister(joinPath, { mode: 'club' })}
      {...buttonProps}
    >
      {children}
    </button>
  );
}
